import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { urlUsr } from '../common';
import { User } from '../models/user';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http: HttpClient) { }

  components

  getUsers() {
    return this.http.get(`${urlUsr}/get-all`);
  }

  getUser(id: string) {
    return this.http.get(`${urlUsr}/get-one/${id}`);
  }
/* Conseguir usuarios por id de team */
  getUsersByIdTeam(data: any) {
    return this.http.post(`${urlUsr}/get-user-team`, data);
  }

  createUser(data: any): Observable<User> {
    return this.http.post(`${urlUsr}/create`, data);
  }

  updateUser(id: string, data: User): Observable<User> {
    return this.http.put(`${urlUsr}/update/${id}`, data);
  }

  getNameOnePerson(id: string) {
    return this.http.get(`${urlUsr}/get-one-person/${id}`);
  }

  deleteUser(data: any) {
    return this.http.post(`${urlUsr}/delete`, data);
  }

  grantedUser(data: any) {
    return this.http.post(`${urlUsr}/granted`, data);
  }

  getDataOnePerson(id: string) {
    return this.http.get(`${urlUsr}/get-data-person/${id}`);
  }

  removeGrantedAdminSurvey(data: any) {
    return this.http.post(`${urlUsr}/remove-privilege`, data);
  }

  grantedGrantedAdminSurvey(data: any) {
    return this.http.post(`${urlUsr}/granted-privilege`, data);
  }
}
